
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities",
      function () {
        return require("private-next-pages/cities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cities"])
      });
    }
  